webpackJsonp([137953525537868],{

/***/ 1423:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Victor Benavente","slug":"blog/author/victor-benavente","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/victor-benavente"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-victor-benavente-b06c7a070a608cd73226.js